export const CREATE_CORR = "CREATE_CORR";
export const UPDATE_CORR = "UPDATE_CORR";
export const DELETE_CORR = "DELETE_CORR";
export const FETCH_CORRS = "FETCH_CORRS";
